import { Component, OnInit } from '@angular/core';
import { SupplierState } from '../../profile/store/state/supplierstate.state';
import { Store, select } from '@ngrx/store';
import { Profile, Location, OwnershipType, Supplier } from '../models/profile.model';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectCurrentUser, SelectSupplierProfile, getGeneralSettings, SelectSupplierContactList,SelectPreventativeInProgress } from '../../profile/store/app.selector';
import { Observable, combineLatest } from 'rxjs';
import { FormControl } from '@angular/forms';
import { StateService } from '../services/state.service';
import { CommonService } from '../services/common.service';
import { ProfileService } from '../services/profile.service';
import { GetGeneralSettings, GetSupplierContactListByCode, GetSupplierProfile, GetSupplierProfileCurrentUser,GetPreventativeInProgress } from '../store/app.actions';
import { UserDetails } from '../models/user.model';
import { AccessRole, ControlType, TabConfig } from '../profile-tab.directory';
import { I18nService } from 'app/shared/services/i18n.service';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {
    tabList: string[] = [];
    supplierCode: any;
    panelOpenState = false;
    currentTab: string;
    newSupplier = "";

    deleteTitle: string;
    deleteConfirmation: string;

    profile: Profile = new Profile();
    obLocations$: Observable<Location[]>;
    obOwnerships$: Observable<OwnershipType[]>;
    obSupplierList$: Observable<Supplier[]>;
    userDetails: UserDetails = null;
    searchSupplier: FormControl = new FormControl('');
    primaryContact: string = null;
    profileAdmin: string = null;
    availableFields: string[] = [];
    tabConfiguration: TabConfig[] = null;
    sqaUrl: string = '';
    supplierSOS: string = '';
    preventativeHold: boolean = false;

    constructor(private route: ActivatedRoute,
        private translate: I18nService,
        private stateService: StateService,
        private commonService: CommonService,
        private service: ProfileService,
        private store: Store<SupplierState>) {
        // this.translate.setDefaultLang('en-US');

        // loading user details
        this.store.dispatch(new GetGeneralSettings());
        this.store.dispatch(new GetSupplierProfileCurrentUser());
    }

    ngOnInit() {
        if (this.route.firstChild) {
            this.route.firstChild.data.subscribe(x => {
                this.currentTab = x["tabName"];
            });
        }

        combineLatest(
            [this.store.pipe(select(SelectCurrentUser)),
            this.route.params])
            .subscribe(([result, params]) => {
                if (result && params) {
                    if (params["code"]) {
                        this.supplierCode = this.commonService.getSupplierCode(params["code"]);
                    }

                    this.userDetails = result;
                    if (this.userDetails.isSupplier && (this.supplierCode === undefined || this.supplierCode === '')) {
                        this.newSupplier = this.userDetails.supplierContact.supplierMaps[0].supplierCode;
                    }

                    if (this.supplierCode && this.userDetails) {
                        this.newSupplier = this.supplierCode;
                        this.loadResources();
                    }
                }
            });
        // this.currentTab = this.defaultTab;
        if (this.supplierCode) { 
            this.store.dispatch(new GetPreventativeInProgress(this.supplierCode,true));
      this.store.pipe(select(SelectPreventativeInProgress)).subscribe(x => {
        if (x) {
          this.preventativeHold = x;
        }
      });
          }
    }
    private loadResources(): void {
        this.translate.getAsync('Delete Item')
            .subscribe(t => this.deleteTitle = t);

        this.translate.getAsync('Are you sure you want to delete this item?')
            .subscribe(t => this.deleteConfirmation = t);

        this.obOwnerships$ = this.service.getOwnershipType();
        this.obLocations$ = this.service.getLocations(this.supplierCode);

        this.store.dispatch(new GetSupplierProfile(this.supplierCode, true));
        this.store.dispatch(new GetSupplierContactListByCode(this.supplierCode, true));

        this.store.pipe(select(SelectSupplierContactList))
            .subscribe((supplierContactResult) => {
                if (supplierContactResult) {
                    const primaryContactUser = supplierContactResult.find(x => x.types && x.types.newValue && x.types.newValue.includes('Primary'));
                    if (primaryContactUser) {
                        this.primaryContact = primaryContactUser.email.newValue;
                    }
                    const profileAdminContact = supplierContactResult.find(x => x.types && x.types.newValue && x.types.newValue.includes('Profile Admin'));
                    if (profileAdminContact) {
                        this.profileAdmin = profileAdminContact.email.newValue;
                    }
                }
            }, err => {
                console.error(`Service call error: GetSupplierContactListByCode or getEntityListByCode. Details: ` + err);
            });

        combineLatest([this.store.pipe(select(SelectSupplierProfile)),
        this.store.pipe(select(getGeneralSettings))])
            .subscribe(([profile, generalSettings]) => {
                if (generalSettings && generalSettings.profileConfiguration) {
                    this.tabConfiguration = generalSettings.profileConfiguration
                        .map(x => new TabConfig(x.name, x.type, x.accessRole, !x.supplierTypes ? "*" : x.supplierTypes, !x.supplierCategories ? [] : x.supplierCategories,
                        x.tierLevel));
                }

                if (profile) {
                    this.profile = profile;
                    this.stateService.currentProfile.next(profile);
                    this.tabList = [];
                    let tabControlConfiguration = [];

                    if (this.userDetails.isSupplier) {
                        tabControlConfiguration = this.tabConfiguration
                            .filter(x => x.controlType === ControlType.Tab
                                && (x.role === AccessRole.Supplier || x.role === AccessRole.All));
                    } else {
                        tabControlConfiguration = this.tabConfiguration
                            .filter(x => x.controlType === ControlType.Tab
                                && (x.role === AccessRole.Tesla || x.role === AccessRole.All));
                    }

                    tabControlConfiguration.forEach((tabItem) => {
                        if (typeof tabItem.supplierTypes === 'string' && tabItem.supplierTypes === "*" && tabItem.tierLevel!=null && 
                        tabItem.tierLevel.toLowerCase().includes(this.profile.tierLevel.toLowerCase())
                        ) {
                            this.tabList.push(tabItem.name);
                        } else if (tabItem.supplierTypes instanceof Array) {
                            if (!this.profile.supplierDetails.supplierCategory) {
                                this.profile.supplierDetails.supplierCategory = [];
                            }

                            if (tabItem.supplierTypes.some(x => this.profile.supplierDetails
                                    .supplierCategory.some(y => y.name === x)) && tabItem.tierLevel!=null
                                    && tabItem.tierLevel.toLowerCase().includes(this.profile.tierLevel.toLowerCase())
                                ) {
                                this.tabList.push(tabItem.name);
                            }
                        }

                        if (!this.profile.supplierDetails.supplierSubCategory) {
                            this.profile.supplierDetails.supplierSubCategory = [];
                        }

                        if (!this.profile.supplierDetails.supplierSubCategory.some(x => x.id === 23 || x.id === 44)) {
                            this.tabList = this.tabList.filter(x => x != 'Loaner Wheel Inventory');
                        }

                        if ((tabItem.name=='EHS Questionnaire' && tabItem.supplierCategories.length == 0)
                             || (tabItem.name=='EHS Questionnaire' && tabItem.supplierCategories.length > 0 && !this.profile.supplierDetails.supplierSubCategory.some(x => tabItem.supplierCategories.includes(x.id)))) {
                            this.tabList = this.tabList.filter(x => x != 'EHS Questionnaire');
                        }
                    });
                }
            }, err => {
                console.error(`Service call error: SelectSupplierProfile. Details: ` + err);
            });
    }
}
